//
// helpers/find-ancestor.js
//
// - find ancestor element having a given class, or null
//
// - NB the element is considered an 'ancestor' of itself, since this is
//   the most useful behaviour
//

export default function find_ancestor(el, c) {
  do {
    if (el.classList.contains(c)) {
      return el;
    }
  } while ((el = el.parentNode) && el !== document);
  return null;
}
